import React from 'react';
import { Tooltip } from '@adserve/adserve-react-components';
import { useContext } from 'react';
import { SystemSettingsContext } from '../../../contexts/SystemSettingsContext';

const CampaignPropertyReservationPriceCell = ({
    data,
    campaignProperties = []
}) => {
    const { formatCurrency } = useContext(SystemSettingsContext);
    return (
        <Tooltip
            text='Reservation Price'
            marginTopAdjustment={10}
            marginLeftAdjustment={-4}
            style={{ width: 125 }}
        >
            <span>
                {formatCurrency(
                    campaignProperties?.find((c) => c.propertyId === data.id)
                        ?.reservationPrice
                )}
            </span>
        </Tooltip>
    );
};

export default CampaignPropertyReservationPriceCell;
